import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ui } from '../config/seoCopy';

/**
 * A visible breadcrumb trail. Paths are unprefixed — the router's basename
 * adds the language. The last item is the current page and is not a link.
 *
 * Pair it with breadcrumbSchema() given the same items: the trail a reader
 * sees and the one in the structured data must match.
 *
 * items: [{ name, to? }]
 */
export default function Breadcrumbs({ items, style }) {
    const { i18n } = useTranslation();
    const U = ui((i18n.language || 'ar').split('-')[0]);
    return (
        <nav aria-label={U.crumbs} style={{ color: '#888', fontSize: '0.9rem', marginBottom: '1.25rem', ...style }}>
            <ol style={{ listStyle: 'none', display: 'flex', flexWrap: 'wrap', gap: '0.4rem', margin: 0, padding: 0 }}>
                {items.map((it, i) => (
                    <li key={`${it.name}-${i}`} style={{ display: 'flex', gap: '0.4rem' }}>
                        {i > 0 && <span aria-hidden="true">›</span>}
                        {it.to && i < items.length - 1
                            ? <Link to={it.to} style={{ color: '#aaa', textDecoration: 'none' }}>{it.name}</Link>
                            : <span aria-current={i === items.length - 1 ? 'page' : undefined}>{it.name}</span>}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
